var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2972 11.1446C11.0003 11.1446 11.5702 10.5881 11.5702 9.90166C11.5702 9.21519 11.0003 8.65869 10.2972 8.65869C9.59421 8.65869 9.02429 9.21519 9.02429 9.90166C9.02429 10.5881 9.59421 11.1446 10.2972 11.1446Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22118 11.1446C6.9242 11.1446 7.49412 10.5881 7.49412 9.90166C7.49412 9.21519 6.9242 8.65869 6.22118 8.65869C5.51816 8.65869 4.94824 9.21519 4.94824 9.90166C4.94824 10.5881 5.51816 11.1446 6.22118 11.1446Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30297 7.78769C5.00599 7.78769 5.5759 7.23119 5.5759 6.54472C5.5759 5.85825 5.00599 5.30176 4.30297 5.30176C3.59994 5.30176 3.03003 5.85825 3.03003 6.54472C3.03003 7.23119 3.59994 7.78769 4.30297 7.78769Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25914 7.78769C8.96217 7.78769 9.53208 7.23119 9.53208 6.54472C9.53208 5.85825 8.96217 5.30176 8.25914 5.30176C7.55612 5.30176 6.98621 5.85825 6.98621 6.54472C6.98621 7.23119 7.55612 7.78769 8.25914 7.78769Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1554 7.78769C12.8584 7.78769 13.4283 7.23119 13.4283 6.54472C13.4283 5.85825 12.8584 5.30176 12.1554 5.30176C11.4524 5.30176 10.8824 5.85825 10.8824 6.54472C10.8824 7.23119 11.4524 7.78769 12.1554 7.78769Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2676 4.77647C10.7808 4.77647 11.1969 4.34699 11.1969 3.81719C11.1969 3.28739 10.7808 2.85791 10.2676 2.85791C9.75432 2.85791 9.33826 3.28739 9.33826 3.81719C9.33826 4.34699 9.75432 4.77647 10.2676 4.77647Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37096 4.77647C6.8842 4.77647 7.30027 4.34699 7.30027 3.81719C7.30027 3.28739 6.8842 2.85791 6.37096 2.85791C5.85772 2.85791 5.44165 3.28739 5.44165 3.81719C5.44165 4.34699 5.85772 4.77647 6.37096 4.77647Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24297 1H12.3953C12.3953 1 13.2501 1.57802 13.6102 1.97519C13.9704 2.37236 14.3134 2.90636 14.5532 3.33778C14.793 3.7692 14.9873 4.15562 15.1527 4.65655C15.318 5.15748 15.4696 5.6794 15.5123 6.33496C15.5551 6.99052 15.4929 7.88752 15.3325 8.55287C15.1721 9.21821 14.874 9.8237 14.6132 10.2912C14.3523 10.7588 14.1613 10.9957 13.8339 11.3702C13.5066 11.7447 13.0764 12.1672 12.635 12.5091C12.1937 12.8511 11.7292 13.1641 11.1964 13.4083C10.6636 13.6525 9.45805 13.9478 9.45805 13.9478C9.45805 13.9478 7.82563 14.1667 6.52082 13.708C6.00219 13.5257 5.66233 13.4635 5.08218 13.1685C4.35542 12.799 3.65545 12.3304 3.10405 11.7299C2.34621 10.9045 1.73885 9.90917 1.36569 8.85259C1.0702 8.01593 0.97343 7.10178 1.00603 6.21508C1.03079 5.54148 1.18834 4.86784 1.42563 4.23694C1.62719 3.70107 1.96919 3.18563 2.26484 2.73836C2.55405 2.30082 3.0633 1.82117 3.40376 1.53949C3.74423 1.25782 4.24297 1 4.24297 1Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 1.52095,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/type2.828e9cc36188b27d87f76faf5ad8f24e.svg";
export { ForwardRef as ReactComponent };